import { render, staticRenderFns } from "./tooling-preview-query-ranking.component.vue?vue&type=template&id=028489bb&scoped=true"
import script from "./tooling-preview-query-ranking.component.vue?vue&type=script&lang=ts"
export * from "./tooling-preview-query-ranking.component.vue?vue&type=script&lang=ts"
import style0 from "./tooling-preview-query-ranking.component.vue?vue&type=style&index=0&id=028489bb&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "028489bb",
  null
  
)

export default component.exports